import React from 'react';
import ReactDOM from 'react-dom';
// @ts-ignore
import {IntlProvider} from 'react-intl';
import {BrowserRouter} from 'react-router-dom';
import {QueryClientProvider} from '@tanstack/react-query';
// scroll bar
import 'simplebar/src/simplebar.css';
// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';
import {HelmetProvider} from 'react-helmet-async';
// contexts
// @ts-ignore
import {SettingsProvider} from './contexts/SettingsContext';
// @ts-ignore
import {CollapseDrawerProvider} from './contexts/CollapseDrawerContext';
import './i18n';
// @ts-ignore
import {AuthProvider} from './contexts/UserContext';
// @ts-ignore
import {queryClient} from './utils/QueryClient';
import 'leaflet/dist/leaflet.css';
// @ts-ignore
import {ShopProvider} from './contexts/ShopContext';
// @ts-ignore
import App from './App';
// import * as Sentry from "@sentry/react";

// Sentry.init({
//   dsn: "https://ad6db50e1e5c99e6cbac42cb71a037ea@sentry.qazvinfood.com/14",
//   release: "1.0.0",
// });

ReactDOM.render(
    <BrowserRouter>

    <AuthProvider>
            <HelmetProvider>
                <IntlProvider locale={'fa'}>
                    <SettingsProvider>
                        <CollapseDrawerProvider>
                            {/* <AxiosProvider> */}
                                <QueryClientProvider client={queryClient}>
                                    <ShopProvider>
                                        <App/>
                                    </ShopProvider>
                                </QueryClientProvider>
                            {/* </QueryClientProvider> */}
                            {/* </AxiosProvider> */}
                        </CollapseDrawerProvider>
                    </SettingsProvider>
                </IntlProvider>
            </HelmetProvider>
        </AuthProvider>
    </BrowserRouter>,
  document.getElementById('root')
);